import axios from "@/repositories/client";

axios.getProfiles = (query, pagination, args) => {

  args.user = args.user || null;

  let options = {
    params: {
      ...(args.user ? {organization_ids: [args.user.organization_id || 1]} : {}), // todo remove || 1 for release
      search: query,
      fields: ['first_name', 'last_name'],
      page: pagination.page,
      size: pagination.size
    }
  };

  return axios.get(`profiles/users`, options)
    .then(response => {
      return response.data;
    });
};

axios.getProfile = (profile, user) => {

  let options = {
    params: {
      organization_ids: [user.organization_id || 1], // todo remove || 1 for release
      search: profile,
      fields: ['user_id'],
      page: 1,
      size: 1
    }
  };

  return axios.get(`profiles/users`, options)
    .then(response => {
      return _.first(response.data.data);
    });
};

axios.getMyProfile = () => {
  return axios.get(`profiles/users/me`)
    .then(response => {
      return response.data;
    });
};

export default axios;